import { render, staticRenderFns } from "./LitigationHome.vue?vue&type=template&id=b3cd6db2&scoped=true&"
import script from "./LitigationHome.vue?vue&type=script&lang=js&"
export * from "./LitigationHome.vue?vue&type=script&lang=js&"
import style0 from "./LitigationHome.vue?vue&type=style&index=0&id=b3cd6db2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3cd6db2",
  null
  
)

export default component.exports